import { DateFilter } from './components/date';
import { SelectFilter } from './components/select';
import { TextFilter } from './components/text';
import { IntegerFilter } from './components/integer';
import { SearchFilter } from './components/search';
export * from './modals';
export function components() {
	return [ DateFilter, SelectFilter, TextFilter, IntegerFilter, SearchFilter ];
}
